import { AppBar, styled } from "@mui/material";
import { IStyledAppBarProps } from "./types";
import { drawerWidth } from "../../../consts/drawerWidth";

const StyledAppBar = styled(AppBar, {
	shouldForwardProp: (prop) => prop !== 'open',
})<IStyledAppBarProps>(({ theme }) => ({
	height: theme.spacing(8),
	backgroundColor: (theme as any).palette.neutral.darker,
	padding: theme.spacing(2),
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	transition: theme.transitions.create(['margin', 'width'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	variants: [
		{
			props: { open: true } as Partial<IStyledAppBarProps>,
			style: {
				width: `calc(100% - ${drawerWidth}px)`,
				marginRight: `${drawerWidth}px`,
				transition: theme.transitions.create(['margin', 'width'], {
					easing: theme.transitions.easing.easeOut,
					duration: theme.transitions.duration.enteringScreen,
				}),
			},
		},
	],
	"& .MuiSvgIcon-root": {
		color: theme.palette.primary.dark
	}
}));

export { StyledAppBar }